import config from '../../../util/config';
import { ReplacePattern, VaultInputType } from './types';

export const setFieldDefaults = ({
  type,
  placeholder,
  maskInput,
  validations = [],
  replacePatterns = [],
}: {
  type: VaultInputType;
  placeholder?: string;
  maskInput?: MaskInput;
  validations?: RegExp[];
  replacePatterns?: ReplacePattern[];
}) => {
  // handle extended field types
  // add defaults if not present
  let fieldType: VgsFieldType;
  let adjustedPlaceholder: string | undefined = placeholder;
  let adjustedMaskInput: MaskInput | undefined = maskInput;
  let adjustedReplacePatterns: ReplacePattern[] = replacePatterns;
  if (type === 'dobDay' || type === 'dobMonth' || type === 'dobYear') {
    fieldType = 'text';
    if (type === 'dobDay') {
      adjustedPlaceholder = placeholder || 'DD';
      adjustedMaskInput = maskInput || {
        mask: 'DD',
        maskChar: null,
        formatChar: { D: '[0-9]' },
      };
      validations.push(/^(0[1-9]|[1-2]\d|3[0-1])$/);
    } else if (type === 'dobMonth') {
      adjustedPlaceholder = placeholder || 'MM';
      adjustedMaskInput = maskInput || {
        mask: 'MM',
        maskChar: null,
        formatChar: { M: '[0-9]' },
      };
      validations.push(/^(0[1-9]|1[0-2])$/);
    } else if (type === 'dobYear') {
      adjustedPlaceholder = placeholder || 'YYYY';
      adjustedMaskInput = maskInput || {
        mask: 'YYYY',
        maskChar: null,
        formatChar: { Y: '[0-9]' },
      };
      if (config.environment === 'prod') {
        const currentYear = new Date().getFullYear();
        const earliestYear = currentYear - 120;
        const latestYear = currentYear - 18;
        const years = [];
        for (let year = earliestYear; year <= latestYear; year++) {
          years.push(year);
        }
        validations.push(new RegExp(years.join('|')));
      }
    }
  } else if (type === 'zip') {
    fieldType = 'text';
    adjustedMaskInput = maskInput || {
      mask: 'XXXXX',
      maskChar: null,
      formatChar: { X: '[0-9]' },
    };
    validations.push(/^\d{5}$/);
  } else if (type === 'ein') {
    fieldType = 'text';
    adjustedPlaceholder = placeholder || 'XX-XXXXXXX';
    adjustedMaskInput = maskInput || {
      mask: 'XX-XXXXXXX',
      maskChar: null,
      formatChar: { X: '[0-9]' },
    };
    validations.push(/^\d{2}-\d{7}$/);
  } else if (type === 'url') {
    fieldType = 'text';
    // valid url
    validations.push(
      /(https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z]{2,}(\.[a-zA-Z]{2,})(\.[a-zA-Z]{2,})?\/[a-zA-Z0-9]{2,}|((https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z]{2,}(\.[a-zA-Z]{2,})(\.[a-zA-Z]{2,})?)|(https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z0-9]{2,}\.[a-zA-Z0-9]{2,}\.[a-zA-Z0-9]{2,}(\.[a-zA-Z0-9]{2,})?/g,
    );
    // does not contain .example.
    validations.push(/^((?!\.example\.).)*$/gi);
    // does not start with example.
    validations.push(/^(?!example\.).+/gi);
    // does not contain @ symbol
    validations.push(/^((?!@).)*$/gi);
  } else if (type === 'phone') {
    fieldType = 'text';
    adjustedPlaceholder = placeholder || '(XXX) XXX-XXXX';
    adjustedMaskInput = maskInput || {
      mask: '(XXX) XXX-XXXX',
      maskChar: null,
      formatChar: { X: '[0-9]' },
    };
    validations.push(/\(\d{3}\) \d{3}-\d{4}/);
    adjustedReplacePatterns = replacePatterns || [{ expression: /[^d]+/g }];
  } else if (type === 'email') {
    fieldType = 'text';
    validations.push(
      /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]{2,})+$/,
    );
  } else if (type === 'year') {
    fieldType = 'text';
    adjustedPlaceholder = placeholder || 'YYYY';
    adjustedMaskInput = maskInput || {
      mask: 'YYYY',
      maskChar: null,
      formatChar: { Y: '[0-9]' },
    };
    validations.push(/^\d{4}$/);
  } else {
    fieldType = type;
    adjustedPlaceholder = placeholder;
    adjustedMaskInput = maskInput;
  }

  if (fieldType === 'ssn') {
    adjustedPlaceholder = placeholder || 'XXX-XX-XXXX';
    adjustedMaskInput = maskInput || {
      mask: 'XXX-XX-XXXX',
      maskChar: null,
      formatChar: { X: '[0-9]' },
    };
    validations.push(/^\d{3}-\d{2}-\d{4}$/);
    if (config.environment === 'prod') {
      // if in production:
      // don't allow digits 1-3 to be 000, 666 or 900-999
      // don't allow digits 4-5 to be 00
      // don't allow digits 6-9 to be 00000
      validations.push(/^(?!000|666|9\d{2})\d{3}-(?!00)\d{2}-(?!0000)\d{4}$/);
      // don't allow 123-45-6789
      validations.push(/^(?!123-45-6789).*$/);
    }
  }

  return {
    type: fieldType,
    placeholder: adjustedPlaceholder,
    maskInput: adjustedMaskInput,
    validations,
    replacePatterns: adjustedReplacePatterns,
  };
};
